import React from 'react';
import { Link, translate, FunctionField, DateField, TextField, SimpleShowLayout, Show } from 'react-admin';
import AmountField from '../../components/fields/AmountField';
import { Card, CardContent, Typography, Table, TableBody, TableRow, TableCell } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { EnhancedLinkField } from '../../components/fields';

export const styles = {
	aside: {
		minWidth: '25em',
		marginLeft: '1em'
	},
	inlineBlock: {
		display: 'inline-flex',
		marginRight: '1rem'
	}
};

const WalletAccountItemShowAside = translate(
	withStyles(styles)(({ record, classes, translate }) => (
		<Card className={classes.aside}>
			{record && (
				<CardContent>
					<Typography>{translate('resources.walletAccountItems.aside.title')}</Typography>
					<Table>
						<TableBody>
							<TableRow>
								<TableCell>
									<Link to={`/${record.transactionOwner.type}s/${record.transactionOwner.id}/show`}>
										{translate('resources.walletAccountItems.links.goToTransferType') +
											record.transactionOwner.type}
									</Link>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</CardContent>
			)}
		</Card>
	))
);

const WalletAccountItemShow = props => (
	<Show {...props} aside={<WalletAccountItemShowAside />}>
		<SimpleShowLayout>
			<TextField source="id" />
			<DateField source="creationDateTime" showTime />
			<AmountField source="amount" />
			<TextField source="amountExchangeRate" />
			<AmountField source="amountOriginalCurrency" />
			<TextField source="customType" />
			<TextField source="description" />
			<AmountField source="feeAmount" />
			<AmountField source="feeAmountOriginalCurrency" />
			<TextField source="feeExchangeRate" />
			<TextField source="itemStatus" />
			<TextField source="itemType" />
			<TextField source="itemSubtype" />
			<EnhancedLinkField source="otherPart" />
			<TextField source="otherPartName" />
			<TextField source="paymentInstrumentId" />
			<TextField source="paymentMethod" />
			<FunctionField
				source="transactionOwner"
				render={record => (
					<span>
						{record.transactionOwner.type}
						<br />
						{record.transactionOwner.id}
					</span>
				)}
			/>
		</SimpleShowLayout>
	</Show>
);

export default WalletAccountItemShow;
